import { render } from "./BaseCheckbox.vue?vue&type=template&id=3b0b943a"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"
script.render = render

export default script